import { LOC_ATTRIBUTE_VALUE_CHANGE, LOC_EVENT_ATTRIBUTE } from "../../locKeys";
import { Trigger } from "./Trigger";

export class AttributeDataChange extends Trigger {
    public attrName: string;
    public condition: string;

    constructor(attrName: string, condition: string) {
        super();

        this.attrName = attrName;
        this.condition = condition;
    }

    public override async validate(): Promise<void> {
        if (!this.attrName)
            throw new Error(await this.getTriggerErrorMessage(LOC_EVENT_ATTRIBUTE, LOC_ATTRIBUTE_VALUE_CHANGE));
    }
}
